import _ from 'lodash'

export default {
  credit: {
    description: 'Credited funds',
    detailed: _.template(`Relating to your <%= account.name %>`),
    route: {
      name: 'account',
      params: {
        id: 'account._id'
      }
    }
  },
  correction: {
    description: 'Correction',
    detailed: _.template(`Relating to your <%= account.name %>`),
    route: {
      name: 'account'
    }
  },
  deposit: {
    description: 'Initial deposit',
    detailed: _.template(`Relating to your <%= account.name %>`),
    route: {
      name: 'account'
    }
  },
  'interest-accrued': {
    description: 'Interest accrued',
    detailed: _.template(`Relating to <%= investment.title %>`),
    route: {
      name: 'co-funding.opportunity',
      params: {
        id: 'investment._id'
      }
    }
  },
  investment: {
    description: 'Made investment',
    detailed: _.template(`Relating to <%= investment.title %>`),
    route: {
      name: 'co-funding.opportunity',
      params: {
        id: 'investment._id'
      }
    }
  },
  refund: {
    description: 'Refunded',
    detailed: _.template(`Relating to <%= investment.title %>`),
    route: {
      name: 'co-funding.opportunity',
      params: {
        id: 'investment._id'
      }
    }
  },
  withdrawal: {
    description: 'Made withdrawal',
    detailed: _.template(`Relating to your <%= account.name %>`),
    route: {
      name: 'account'
    }
  }
}
